import React, { Component } from "react";
import axios from 'axios';
import Loading from './Loading';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'tachyons';
import './Portfolio.css';


class ProjectCards extends Component {
    state = {
        project: []
    };

    componentDidMount() {
        this.getProject();
    }

    getProject() {
        axios
            .get('https://adityababar07.pythonanywhere.com/api/v1/project/')
            // .get('http://127.0.0.1:8000/api/v1/project/')
            .then(res => {
                this.setState({ project: res.data })
            })
            .catch(err => {
                console.log(err);
            });

    }
    render() {
        const loaded = this.state.project.length;
        if (loaded !== 0) {
            return (<div>
                {this.state.project.map(item => (
                    <div className="project card project_card_width m-2">
                        <img src={item.project_image} className="card-img-top" alt={item.project_name} />
                        <div className="card-body">
                            <h5 className="card-title">{item.project_name}</h5>
                            <p className="card-text text-break">{item.project_description}</p>
                            <a href="/err" className="btn btn-primary">Read More...</a>
                        </div>
                        <div className="card-footer">
                            <small className="text-muted">last updated on {item.updated_at}</small>
                        </div>
                    </div>
                ))}
            </div>
            )
        }
        else if (loaded === 0) {
            return (
                <div className="tc m-5 p-5">
                    <p className="fs-1 fw-bolder black-80 athelas">
                        Loading ...
                        <hr />
                    </p>
                    <Loading />
                </div>
            )
        }
    }
}

export default ProjectCards;